import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import { Link } from "react-router-dom"

import ThemeConsumer from "../ThemeConsumer"

const Button = ({
  children,
  theme,
  buttonStyle,
  onClick,
  toLinkBtn,
  isLink,
  url,
  width,
  fontSize,
  fontWeight,
  type,
  disabled,
  className,
  id
}) => {
  const generalClass = classNames(
    { [theme[fontWeight]]: fontWeight },
    { [theme[fontSize]]: fontSize }
  )

  const buttonClass = classNames(
    className,
    theme.button,
    theme[buttonStyle],
    { [theme["button:disabled"]]: disabled },
    { [theme["to-link"]]: toLinkBtn },
    { [theme[width]]: width },
    generalClass
  )

  const linkClass = classNames({ [theme["to-link"]]: isLink }, generalClass)

  if (isLink) {
    return (
      <Link
        to={url === "/AreaClienteCorporativo" ? "" : url}
        className={linkClass}
        id={id}
      >
        {children}
      </Link>
    )
  }

  return (
    <button
      id={id}
      type={type}
      className={buttonClass}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  )
}

Button.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node,
  type: PropTypes.string,
  toLinkBtn: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  isLink: PropTypes.bool,
  url: PropTypes.string,
  theme: PropTypes.shape({
    button: PropTypes.string,
    "button:disabled": PropTypes.string,
    "to-link": PropTypes.string
  }),
  width: PropTypes.oneOf(["small", "medium", "large", "extra-large"]),
  buttonStyle: PropTypes.oneOf(["primary", "secondary"]),
  fontSize: PropTypes.oneOf(["f-14", "f-16"]),
  fontWeight: PropTypes.oneOf(["fw-5", "fw-6", "fw-7"]),
  className: PropTypes.string
}

Button.defaultProps = {
  children: null,
  disabled: false,
  type: "button",
  toLinkBtn: false,
  onClick: null,
  theme: {},
  width: "large",
  buttonStyle: "primary",
  fontSize: "f-14",
  fontWeight: "fw-7"
}

export default ThemeConsumer("UIButton")(Button)



// WEBPACK FOOTER //
// ./src/shared/components/Button/Button.js